import styled from "styled-components";
import { MENU_COLORS } from "@lhd/constants";
interface StyledButtonProps {
  isFull?: boolean;
}
export const StyledButton = styled.div<StyledButtonProps>`
  ${({ isFull }) => isFull && "width: 100%;"}

  .button-cancel-common {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1e3665;
    color: #ffffff;
    padding: 0px 8px;
    font-size: inherit;
    font-weight: 600;
    cursor: pointer;
    height: 40px;
    border-radius: 2px;
    min-width: 60px;
    line-height: 1;
    box-sizing: border-box;
    border: 1px solid transparent;
    .button-content {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      gap: 6px;
    }

    .button-loading,
    .button-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .button-text {
      display: block;
      line-height: 1;
      white-space: nowrap;
      transform: translateY(0px);
    }

    &:hover {
      color: #40a9ff;
    }
    &.cancel-btn:not(:disabled) {
      background-color: ${MENU_COLORS.DELETE_ALL};
      color: ${MENU_COLORS.TEXT_WHITE};

      &:hover {
        background-color: ${MENU_COLORS.DELETE_HOVER};
        color: ${MENU_COLORS.TEXT_WHITE};
      }
    }
    &.hidden {
      background-color: transparent;
    }
    &:disabled {
      background-color: #d9dde5;
      cursor: not-allowed;
      color: #9ca3af !important;
      font-weight: 400;
    }
    &.notEditable {
      cursor: default;
      background-color: #d9dde5;
    }
    .icon {
      display: flex;
      align-items: center;
    }
  }
`;
